import { User } from '../models'
import * as fromAuthActions from './auth.actions'

export interface State {
  loggedIn: boolean
  loggingIn: boolean
  loggingOut: boolean
  user: User
}

export const initialState: State = {
  loggedIn: false,
  loggingIn: true,
  loggingOut: true,
  user: {},
} as State

export function reducer(state = initialState, action: fromAuthActions.AuthActions): State {
  switch (action.type) {
    case fromAuthActions.GET_CURRENT_USER: {
      return {
        ...state,
        loggingIn: true,
      }
    }
    case fromAuthActions.GET_CURRENT_USER_SUCESS: {
      return {
        ...state,
        loggedIn: true,
        loggingIn: false,
        user: action.payload,
      }
    }

    case fromAuthActions.GET_CURRENT_USER_ERROR: {
      return {
        ...state,
        loggingIn: false,
      }
    }

    case fromAuthActions.LOGOUT: {
      return {
        ...initialState,
        loggingOut: true,
      }
    }

    case fromAuthActions.LOGOUT_SUCCESS: {
      return {
        ...initialState,
        loggingOut: false,
      }
    }

    default: {
      return state
    }
  }
}

export const getLoggedIn = (state: State) => state.loggedIn
export const getIsLoggingIn = (state: State) => state.loggingIn
export const getIsLoggingOut = (state: State) => state.loggingOut
export const getUser = (state: State) => state.user
export const getPrivileges = (state: State) => getUser(state).accessRoles
export const getLocaleString = (state: State) => getUser(state).languageCode



// WEBPACK FOOTER //
// ./src/app/auth/store/auth.reducer.ts